export const getAppDomain = (state) => state.app_domain
